<template>
  <div class="box">
    <ul  v-if="list.length != 0">
      <li v-for='(item,index) in list' :key='index'>
        <router-link :to="{path:'/setting/newsDetail',query:{id:item.id}}">
          <b></b>
          <p>{{item.title}}</p>
          <span>{{item.createAt}}</span>
        </router-link>
      </li>
    </ul>
    <div style="text-align: center;margin-top: 35%;font-size: 20px;" v-if="list.length == 0">
         暂无信息
    </div>
  </div>
</template>

<script>
  import {
    news_list
  } from '@/axios/api.js'
  export default {
    data() {
      return {
        category: '',
        list: []
      }
    },
    methods: {
    },
    mounted() {
      this.category = localStorage.getItem("category");
      var data = {
        category : this.category,
        start: 0,
        type:18,
        count: 100
      }
      news_list(data).then(res => {
        if (res.data.code == 0) {
          // this.list = res.data.obj;
        } else {
          this.$message(res.data.msg);
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  }
</script>
<style scoped="scoped">
  .box{
    margin-top: 40px;
  }
  ul li{
    margin-bottom: 30px;
    cursor: pointer;
    position: relative;
    padding-left: 25px;
  }
  li b{
    position: absolute;
    left: 0;
    top: 5px;
    font-weight: normal;
    width: 11px;
    height: 11px;
    border: 3px solid #D9E7FF;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }
  li p{
    font-size: 16px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  li span{
    margin-top: 10px;
    padding-bottom: 15px;
    display: block;
    font-size: 14px;
    color: #999;
    border-bottom: 1px solid #E5E5E5;
  }
  li:hover p{
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/notice.vue